import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false,
})
export class FooterComponent implements OnInit {

  CurrYear:any;

  constructor() { }

  ngOnInit() {
    var date = new Date();
    this.CurrYear = date.getFullYear().toString();
  }

}
